"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../../style/variables");
var context_1 = require("./context");
var SIZE_MAP = {
    small: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_SM + ")",
    default: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_MD + ")",
    large: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_LG + ")",
};
var ButtonIcon = function (_a) {
    var Icon = _a.icon;
    var size = context_1.useButtonContext().size;
    return (react_1.jsx(Icon, { css: {
            width: SIZE_MAP[size],
            height: SIZE_MAP[size],
        } }));
};
exports.default = ButtonIcon;
